/**
 * IWHC Moods — Tab switching
 */
(function() {
  'use strict';

  function init() {
    var tabsContainer = document.querySelector('[data-mood-tabs]');
    if (!tabsContainer) return;

    var tabs = tabsContainer.querySelectorAll('[data-mood-tab]');
    var panels = document.querySelectorAll('[data-mood-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = tab.dataset.moodTab;

        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');

        panels.forEach(function(p) { p.classList.remove('active'); });
        var target = document.querySelector('[data-mood-panel="' + index + '"]');
        if (target) target.classList.add('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
